import { api_fetch } from "@/api/client.tsx"
import { DeductionExt } from "@/api/deduction.tsx"
import { UserState } from "@/auth/user.tsx"
import { SimpleSelect } from "@/components/simple_select.tsx"
import { toast } from "@/components/ui/use-toast.ts"
import { isSuperCoffeeUser } from "@/utils/index.tsx"
import { DEDUCTION_STATUS_LABELS } from "@/utils/deduction_status_labels"
import { STATUS_ICONS } from "./columns.tsx"

// Base status type
type BaseStatusValue =
  | "new"
  | "validated"
  | "disputable"
  | "backup_requested"
  | "backup_received"
  | "review"
  | "task_assigned"
  | "disputed"
  | "won"
  | "lost"
  | "archived"

// Super user additional statuses
type SuperUserStatusValue = "expensable" | "pending"

// Combined type that makes super user values optional
export type StatusValue = BaseStatusValue | SuperUserStatusValue

// Type the object to accept all base values and optional super user values
export let STATUS_VALUES: Record<BaseStatusValue, string> & Partial<Record<SuperUserStatusValue, string>> = {
  new: DEDUCTION_STATUS_LABELS.new,
  validated: DEDUCTION_STATUS_LABELS.validated,
  disputable: DEDUCTION_STATUS_LABELS.disputable,
  backup_requested: DEDUCTION_STATUS_LABELS.backup_requested,
  backup_received: DEDUCTION_STATUS_LABELS.backup_received,
  review: DEDUCTION_STATUS_LABELS.review,
  task_assigned: DEDUCTION_STATUS_LABELS.task_assigned,
  disputed: DEDUCTION_STATUS_LABELS.disputed,
  won: DEDUCTION_STATUS_LABELS.won,
  expensable: DEDUCTION_STATUS_LABELS.expensable,
  lost: DEDUCTION_STATUS_LABELS.lost,
  archived: DEDUCTION_STATUS_LABELS.archived,
}

interface StatusSelectProps {
  deduction: DeductionExt
  onStatusChange?: () => void
}

export function StatusSelect({ deduction, onStatusChange }: StatusSelectProps) {
  let initialValue = deduction.status_value || "new"
  const user = UserState.use()
  if (isSuperCoffeeUser(user?.org_id)) {
    STATUS_VALUES = {
      ...STATUS_VALUES,
      pending: DEDUCTION_STATUS_LABELS.pending,
    }
  }

  async function handleOnChange(_s: string) {
    let newStatus = _s as keyof typeof STATUS_VALUES
    const res = await api_fetch("/statuses", {
      method: "POST",
      body: [
        {
          deduction_id: deduction.id,
          status: newStatus,
        },
      ],
    })

    if (res.ok) {
      console.log("Status updated successfully")
      toast({
        title: "Status Updated",
        description: `Status changed to ${STATUS_VALUES[newStatus]}`,
      })
      onStatusChange?.()
    } else {
      console.error("Failed to update status")
    }
  }

  return <SimpleSelect value={initialValue} onChange={handleOnChange} values={STATUS_VALUES} icons={STATUS_ICONS} />
}
